export default "__VITE_ASSET__V4gg9V94__"